module.exports = __webpack_public_path__ + "static/media/online-doctor.da9ec52a.svg";